module.exports = __webpack_public_path__ + "img/ibbil-cover.ccdbfa7b.jpg";